import type { EditProps } from "react-admin";
import { BooleanInput, Edit, SimpleForm, TextInput } from "react-admin";
import GroupedPermissionsInput from "@/components/GroupedPermissionsInput";
import { MadrasaOfficePresetButton } from "@/components/madrasa-office-preset/MadrasaOfficePresetButton";

const AdminEdit = (props: EditProps) => (
  <Edit {...props} mutationMode="optimistic">
    <SimpleForm>
      <TextInput source="name" />
      <TextInput source="email" />
      <TextInput source="phoneNumber" helperText="Optional E.164 phone (e.g. +919876543210)" />
      <BooleanInput
        label="Receive Male sadarat allocation reminders via WhatsApp"
        source="receiveSadaratAllocationRemindersMale"
        helperText="Requires a phone number. Daily digest when events still need a Male sadarat."
        fullWidth
        defaultValue={false}
      />
      <BooleanInput
        label="Receive Female sadarat allocation reminders via WhatsApp"
        source="receiveSadaratAllocationRemindersFemale"
        helperText="Requires a phone number. Daily digest when events still need a Female sadarat."
        fullWidth
        defaultValue={false}
      />
      <BooleanInput
        label="Receive same-day raza event reminders via WhatsApp"
        source="receiveRazaEventDayOfReminders"
        helperText="Requires a phone number. Morning WhatsApp for today's events that need sadarat."
        fullWidth
        defaultValue={false}
      />
      <BooleanInput
        label="Staff leave WhatsApp approver"
        source="receiveStaffLeaveApproverNotifications"
        helperText="Requires a phone number. Enables leave-approver bot identity and pending-leave WhatsApp notifies. Also grant Employees view and edit so they can review leave in JMS."
        fullWidth
        defaultValue={false}
      />
      <MadrasaOfficePresetButton />
      <GroupedPermissionsInput source="permissions" reference="admins/permissions/available" />
    </SimpleForm>
  </Edit>
);

export default AdminEdit;
